import {
  SettingsActionTypes,
  GET_PREFERENCES,
  SET_PREFERENCES,
  SettingsProps,
  SET_SETTINGS,
} from './types';

const initialState: SettingsProps = {
  preferences: {},
  settings: {
    terms: '',
    termscz: '',
    termsit: '',
    aboutus: '',
    faqs: [],
  },
};

export const settingsReducer = (
  state = initialState,
  action: SettingsActionTypes
) => {
  const { type, preferences, settings } = action;
  switch (type) {
    case GET_PREFERENCES:
      return state;
    case SET_PREFERENCES:
      return { ...state, preferences: preferences };
    case SET_SETTINGS:
      return { ...state, settings };
    default:
      return state;
  }
};
